import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ProductCoverageSelectionComponent.metadata.json5';

import styles from '../Miscellanous.module.scss';
import { TranslatorContext } from '@jutro/legacy/locale';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProductCoverageSelectionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductCoverageSelectionComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const translator = useContext(TranslatorContext);

    modelVM.value.isValidationReq = true
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        productType: {
            defaultValue: _.filter(submissionVM.lobData.proLine.coverables.miscellanousCoverable.productCoverageSelection.productType.aspects.availableValues[0].typelist.filters[2].codes, {
                code: 'misProCA'
            }).map((i) => {
                const name = translator({ id: i.name });
    
                return { code: i.code, name }
            }),
            availableValues: _.chain(submissionVM)
                .get(
                'lobData.proLine.coverables.miscellanousCoverable.productCoverageSelection.productType.aspects.availableValues[0].typelist.filters[2].codes',
                []
                )
                .map(i => ({ code: i.code, name: translator({ id: i.name }) ?? i.name ?? i.code }))
                .value()
        },
        equBre8: {
            visible: !_.isUndefined(modelVM.value.pro7) && modelVM.value.pro7
        },
        cri9: {
            visible: !_.isUndefined(modelVM.value.pro7) && modelVM.value.pro7
        },
        empPraLia6: {
            visible: !_.isUndefined(modelVM.value.isPPLEmpPraLiaFldVisible) && modelVM.value.isPPLEmpPraLiaFldVisible
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if(['errOmiLia3', 'cybLia4', 'empPraLia6'].includes(changedPath)) {
                // eslint-disable-next-line no-param-reassign
                value = true
            }

            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={handleValueChange}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductCoverageSelectionComponent.propTypes = wizardProps;
export default withRouter(ProductCoverageSelectionComponent);
